import React, {Component} from "react";
import {constants} from "../data/constants";
import {downLoadVisit} from "../data/analytics";

export class Header extends Component {

	render() {
		return (
			<header id="header">
				<div className="intro">
					<div className="overlay">
						<div className="container">
							<div className="row">
								<div className="col-md-6 my-auto pt-5">
									<h1 className={"pt-5"}>
										<br/>
										Tracking your licensure hours is a drag.<br/>
										Let's fix that
									</h1>
									<br/>
									<p>
										{this.props.data ? this.props.data.paragraph : "Loading"}
									</p>
									<div>

										<div className="row pl-2">
											<a onClick={() => downLoadVisit('ios', this.props.source)}>
												<img src="img/app-store.svg" height="45" width="auto" alt="Appstore download image"/>
											</a>
											<span className="download-space"></span>
											<a onClick={() => downLoadVisit('android', this.props.source)}>
												<img src="img/play-store.svg" height="45" width="auto" alt="Playstore download image"/>
											</a>
										</div>
									</div>
								</div>

								<div className="col-md-6 my-auto py-5">
									<img src="img/header-phone-white.png" className={"mt-5 pull-right"} height="600" width={"auto"}
											 alt="Header iphone image"/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.jsx